import React, { useEffect, useRef, useState } from "react";

import { ChatMessageInterface } from "../../../ChatInterfaces";
import { parseBotMessage, splitDate } from "../../../ChatScripts";
import { changeMessageContent } from "../../../firebaseCRUD";
import { Message } from "../../../../../../BP2Components";

interface ChatMessageProps {
   message: ChatMessageInterface;
   index: number;
   oldId: number;
   currentRoomMessages: ChatMessageInterface[];
   handleSendEmail: any;
}

const ChatMessage: React.FC<ChatMessageProps> = ({
   message,
   index,
   oldId,
   currentRoomMessages,
   handleSendEmail,
}) => {
   const [editedMessage, setEdditedMessage] = useState<any>("");
   const [textAreaHeight, setTextAreaHeight] = useState("auto");

   const botMessageContainerRef = useRef<HTMLDivElement>(null);

   useEffect(() => {
      if (botMessageContainerRef.current) {
         const height = botMessageContainerRef.current.clientHeight;
         //looks beter with that +5
         setTextAreaHeight(`${height + 5}px`);
      }
   }, [editedMessage]);

   const isSameUserAsPrevious =
      index > 0 && currentRoomMessages[index - 1]?.userId === message.userId;

   const messageOwner = message.userId === oldId ? "own-message" : "other-message";
   const marginClass = isSameUserAsPrevious ? "small-margin" : "large-margin";

   const showUserName = !isSameUserAsPrevious;

   // render date at the end of the row of users messages
   const shouldDisplayMessageDate = (messages) => {
      // Get the next message in the list to check if it's from the same user
      const nextUserMessage = messages[index + 1];

      // Display the date if there is no next message
      // or if the next message is from a different user
      return !nextUserMessage || nextUserMessage.userId !== message.userId;
   };

   const handeEditMessage = (e) => {
      e.preventDefault();

      const newText = e.target.value;

      let updatedMessage = { ...editedMessage };

      if (updatedMessage?.content) {
         try {
            let parsedContent = JSON.parse(updatedMessage.content);

            parsedContent.suggestedEmailText = newText;

            updatedMessage.content = JSON.stringify(parsedContent);

            setEdditedMessage(updatedMessage);
         } catch (error) {
            console.error("Błąd przy parsowaniu content:", error);
         }
      }
   };

   const handleEditMessageMode = (e, message) => {
      e.preventDefault();
      setEdditedMessage(message);
   };

   const handleChangeMessageContent = (e) => {
      e.preventDefault();
      if (editedMessage !== "") {
         changeMessageContent("/messages", editedMessage?.key, editedMessage?.content);
         setEdditedMessage("");
      }
   };

   const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>();

   const blockSpamming = () => {
      Message.warning("One click per minute!");

      setIsButtonDisabled(true);
      setTimeout(() => {
         setIsButtonDisabled(false);
      }, 60000);
   };

   return (
      <div
         key={message.messageId}
         className={`main-messages-container__message ${messageOwner} ${marginClass}`}
      >
         <div className="message-content-container">
            {showUserName && (
               <div className="message-user">
                  {messageOwner === "other-message" && message.chatUser}
               </div>
            )}
            {message?.type === "mail" && (
               <div
                  contentEditable={true}
                  className="chat-summary__input"
                  dangerouslySetInnerHTML={{ __html: message?.content }}
               />
            )}
            {message?.type === "botMessage" && (
               <div className="message-content">
                  {parseBotMessage(message?.content)?.responseForUser}
                  <div
                     style={{
                        ...(parseBotMessage(message?.content)?.suggestedEmailText === "" && {
                           display: "none",
                        }),
                        ...(editedMessage?.key === message?.key
                           ? { minHeight: "115px" }
                           : { minHeight: "75px" }),
                     }}
                     className="message-content__main-bot-message_container"
                  >
                     {parseBotMessage(message?.content)?.suggestedEmailText !== "" && (
                        <>
                           <hr />
                           {/* @ts-ignore */}
                           {editedMessage?.key === message?.key ? (
                              <textarea
                                 onChange={(e) => handeEditMessage(e)}
                                 style={{
                                    width: "98%",
                                    backgroundColor: "white",
                                    resize: "none",
                                    borderRadius: "5px",

                                    height: textAreaHeight,
                                    border: "none",
                                    outline: "none",
                                 }}
                              >
                                 {parseBotMessage(message?.content)?.suggestedEmailText}
                              </textarea>
                           ) : (
                              <div ref={botMessageContainerRef} style={{ whiteSpace: "pre-wrap" }}>
                                 {parseBotMessage(message?.content)?.suggestedEmailText}
                              </div>
                           )}
                           {parseBotMessage(message?.content)?.assistantUtils?.sender?.length >
                           0 ? (
                              <>
                                 <div className="border-elements">
                                    <div
                                       style={{ marginTop: "9px" }}
                                       className="half-round-border"
                                    ></div>
                                    <div
                                       style={{ marginTop: "8px" }}
                                       className="half-round-border"
                                    ></div>
                                    {editedMessage?.key === message?.key && (
                                       <div
                                          style={{ marginTop: "8px" }}
                                          className="half-round-border"
                                       ></div>
                                    )}
                                 </div>
                                 <div className="handling-bot-mail-response-buttons">
                                    <div>
                                       {editedMessage?.key === message?.key && (
                                          <div
                                             onClick={(e) => setEdditedMessage("")}
                                             title="cancel editing"
                                             className="handling-bot-mail-response-buttons__mail-response-handling-button"
                                          >
                                             <span className="material-symbols-outlined">
                                                close
                                             </span>
                                          </div>
                                       )}
                                       <div
                                          title="edit suggested email"
                                          className="handling-bot-mail-response-buttons__mail-response-handling-button"
                                       >
                                          {/* @ts-ignore */}
                                          {editedMessage?.key === message?.key ? (
                                             <span
                                                onClick={(e) => handleChangeMessageContent(e)}
                                                className="material-symbols-outlined"
                                             >
                                                done_all
                                             </span>
                                          ) : (
                                             <span
                                                onClick={(e) => handleEditMessageMode(e, message)}
                                                className="material-symbols-outlined"
                                             >
                                                edit
                                             </span>
                                          )}
                                       </div>
                                       <div
                                          title="send suggested mail to sender"
                                          className="handling-bot-mail-response-buttons__mail-response-handling-button"
                                       >
                                          <span
                                             onClick={(e) => {
                                                if (isButtonDisabled) {
                                                   blockSpamming();
                                                } else {
                                                   handleSendEmail(e, message);
                                                   blockSpamming();
                                                }
                                             }}
                                             className="material-symbols-outlined"
                                             style={{
                                                cursor: isButtonDisabled
                                                   ? "not-allowed"
                                                   : "pointer",
                                                opacity: isButtonDisabled ? 0.5 : 1,
                                             }}
                                          >
                                             send
                                          </span>
                                       </div>
                                    </div>
                                 </div>
                              </>
                           ) : null}
                        </>
                     )}
                  </div>
               </div>
            )}

            {message?.type === "message" && (
               <div className="message-content">{message?.content}</div>
            )}

            {shouldDisplayMessageDate(currentRoomMessages) && (
               <div className="message-date">{splitDate(message?.date)}</div>
            )}
         </div>
      </div>
   );
};

export default ChatMessage;
